export default process.env.REACT_APP_API_ADDRESS
  ? process.env.REACT_APP_API_ADDRESS + "/v1/"
  : "https://api.iaho.ir/v1/";



// WEBPACK FOOTER //
// ./src/utils/APIEndPointAddress.js